module.exports = __webpack_public_path__ + "static/media/gosend_icon.0b1fa425.svg";